<script setup>
import { provide } from "vue";
import { useAppConfig } from "~/composables/useAppConfig";

const { isAdmin, appVersion, anonymousAccess } = useAppConfig();

provide("isAdmin", isAdmin);
provide("appVersion", appVersion);
provide("anonymousAccess", anonymousAccess);
</script>

<template>
  <RouterView />
</template>
